import styled from "styled-components";

export const WrapperHeader = styled.header`
  padding: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  a {
    text-decoration: none;
    color: black;
  }

  .header__content {
    display: flex;
    align-items: center;
    gap: 10;
  }

  .header__content-logo {
    width: 45px;
    height: 45px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .header__title-section {
    font-size: 30px;
    margin-left: 15px;
    margin-bottom: 0;
  }

  .header__text-action {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    .header__title-section {
      font-size: 20px;
    }
  }
`;
